import { render, staticRenderFns } from "./valueDetail.vue?vue&type=template&id=e5d83b6e"
import script from "./valueDetail.vue?vue&type=script&lang=js"
export * from "./valueDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports